import { client } from '../client';
import { ICase } from './types/ICase';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export interface IAssignProviderCase {
  provider_id: number;
}

export const assignProvider = async (
  case_id: number,
  payload: IAssignProviderCase,
  userRole?: string,
): Promise<ICase> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.patch(`${prefix}/cases/${case_id}/assign_provider`, payload);

  return data;
};
